import { SimpleGrid as SimpleGridMantine } from "@mantine/core";
import styled from "styled-components";

export const SimpleGrid = styled(SimpleGridMantine)``;
